import React from 'react'
import { Link as MuiLink } from 'react-router-dom'
import { spacing } from '@material-ui/system'
import styled from 'styled-components'
import { urlFor } from 'src/routes'

const Link = styled(MuiLink)(spacing)

interface Notification {
  newObject?: any
  message?: string
}

export const Notification = ({ newObject, message }: Notification) => (
  <span>
    {message}
    {newObject && (
      <Link to={urlFor(newObject) as string} ml={2}>
        View
      </Link>
    )}
  </span>
)
